const config = JSON.parse(process.env.VUE_APP_LUMIERE_CONFIG);
export default config;
